import { GaEventDirective } from './event.directive';

export const Directives = [
	GaEventDirective,
];
